module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/components/event-search-select/event-search-select.component.scss
// module id = ./src/app/modules/backstage-module/components/event-search-select/event-search-select.component.scss
// module chunks = 9